import { useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { GET_EMAIL_CLICK_THROUGH_RATIO, GET_EMAIL_GOALS_AND_CAMPAIGNS } from 'automation-ui-action-features/actions/email/EmailQueries';
export function useEmailStats({
  flowId,
  flowObjectTypeId,
  actionId,
  contentId
}) {
  const skip = flowObjectTypeId !== CONTACT_ID;
  const {
    data: goalsAndCampaignsData
  } = useQuery(GET_EMAIL_GOALS_AND_CAMPAIGNS, {
    variables: {
      flowId
    },
    skip
  });
  const emailCampaigns = getIn(['emailGoalsAndCampaigns', 'emailCampaigns'], goalsAndCampaignsData);
  const emailCampaign = emailCampaigns && emailCampaigns.find(campaign => campaign.emailContentId === contentId);
  const {
    data: clickThroughData
  } = useQuery(GET_EMAIL_CLICK_THROUGH_RATIO, {
    variables: {
      campaignId: emailCampaign ? emailCampaign.emailCampaignId : NaN
    },
    skip: skip || !emailCampaign
  });
  return {
    clickThroughRatio: clickThroughData && clickThroughData.emailClickThroughRatio,
    goalsMet: getIn(['emailGoalsAndCampaigns', 'goalCountsByActionId', actionId], goalsAndCampaignsData)
  };
}